// import React, { useState } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const LoginPage = () => {
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     try {
//       // Change this to your live URL when pushing to Render
//       const API_BASE = "https://haus-of-aura-backend.onrender.com"; 
//       const res = await axios.post(`${API_BASE}/admin/login`, { password });
      
//       if (res.data.success) {
//         localStorage.setItem('adminToken', res.data.token);
//         navigate('/admin-aura');
//       }
//     } catch (err) {
//       setError('Unauthorized access. Please enter the correct password.');
//     }
//   };

//   return (
//     <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#FBF9F6' }}>
//       <form onSubmit={handleLogin} style={{ background: 'white', padding: '50px', borderRadius: '25px', boxShadow: '0 10px 40px rgba(0,0,0,0.05)', textAlign: 'center', maxWidth: '400px', width: '90%' }}>
//         <h1 style={{ fontFamily: 'serif', color: '#3D2B1F', marginBottom: '10px' }}>Haus Of Aura</h1>
//         <p style={{ color: '#888', fontSize: '14px', marginBottom: '30px', letterSpacing: '1px' }}>ADMINISTRATOR LOGIN</p>
        
//         {error && <p style={{ color: '#cf1322', background: '#fff1f0', padding: '10px', borderRadius: '8px', fontSize: '13px' }}>{error}</p>}
        
//         <input 
//           type="password" 
//           placeholder="Enter Admin Password" 
//           value={password} 
//           onChange={(e) => setPassword(e.target.value)}
//           style={{ width: '100%', padding: '15px', marginBottom: '20px', borderRadius: '12px', border: '1px solid #eee', outline: 'none', background: '#fbf9f6', boxSizing: 'border-box' }}
//         />
        
//         <button type="submit" style={{ width: '100%', padding: '15px', background: '#3D2B1F', color: 'white', border: 'none', borderRadius: '50px', fontWeight: '600', cursor: 'pointer', transition: '0.3s' }}>
//           Verify Access
//         </button>
//       </form>
//     </div>
//   );
// };

// export default LoginPage;

import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // This automatically picks the right URL depending on where you are running the site
  const API_BASE = window.location.hostname === "localhost" 
    ? "http://localhost:5001/api/bookings" 
    : "https://haus-of-aura-backend.onrender.com/api/bookings";

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    
    try {
      // The full path must be BASE + /admin/login
      const res = await axios.post(`${API_BASE}/admin/login`, { password });
      
      if (res.data.success) {
        localStorage.setItem('adminToken', res.data.token);
        navigate('/admin-aura');
      }
    } catch (err) {
      console.error("Login Error:", err);
      setError('Unauthorized access. Please enter the correct password.');
    }
  };

  return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#FBF9F6' }}>
      <form onSubmit={handleLogin} style={{ 
        background: 'white', 
        padding: '50px', 
        borderRadius: '25px', 
        boxShadow: '0 10px 40px rgba(0,0,0,0.05)', 
        textAlign: 'center', 
        maxWidth: '400px', 
        width: '90%' 
      }}>
        <h1 style={{ fontFamily: 'serif', color: '#3D2B1F', marginBottom: '10px' }}>Haus Of Aura</h1>
        <p style={{ color: '#888', fontSize: '14px', marginBottom: '30px', letterSpacing: '1px' }}>ADMINISTRATOR LOGIN</p>
        
        {error && (
          <p style={{ 
            color: '#cf1322', 
            background: '#fff1f0', 
            padding: '10px', 
            borderRadius: '8px', 
            fontSize: '13px',
            marginBottom: '20px'
          }}>
            {error}
          </p>
        )}
        
        <input 
          type="password" 
          placeholder="Enter Admin Password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{ 
            width: '100%', 
            padding: '15px', 
            marginBottom: '20px', 
            borderRadius: '12px', 
            border: '1px solid #eee', 
            outline: 'none', 
            background: '#fbf9f6', 
            boxSizing: 'border-box' 
          }}
        />
        
        <button type="submit" style={{ 
          width: '100%', 
          padding: '15px', 
          background: '#3D2B1F', 
          color: 'white', 
          border: 'none', 
          borderRadius: '50px', 
          fontWeight: '600', 
          cursor: 'pointer', 
          transition: '0.3s' 
        }}>
          Verify Access
        </button>
      </form>
    </div>
  );
};

export default LoginPage;